import { Component, OnInit } from "@angular/core";
import { UsersService } from "@service/users.service";
import { AuthService } from "@service/auth.service";
import { PageEvent, MatTableDataSource } from "@angular/material";
import { UserExtract } from "@model/admin/user-extract";
import { Paginate } from "@model/admin/paginate";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-extract",
  templateUrl: "./extract.component.html",
  styleUrls: ["./extract.component.scss"],
})
export class ExtractComponent implements OnInit {
  public extract = [];
  public dataSource = new MatTableDataSource<any>();
  public displayedColumns: string[] = [
    "date",
    "description",
    "value",
    "points",
    "total",
    "status",
  ];
  public total = 0;
  public userTotal = 0;
  public savedValues = [];
  public pageEvent: PageEvent;
  public page: Paginate<UserExtract> = {
    per_page: 5,
    current_page: 0,
    totalElements: 0,
  } as Paginate<UserExtract>;
  public pageSizeOptions: number[] = [5, 10, 20];
  public requestForm: FormGroup;
  public invitedUsers: number;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private usersService: UsersService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.getExtract({
        previousPageIndex: 0,
        pageIndex: this.page.current_page,
        pageSize: this.page.per_page,
        length: this.page.totalElements,
      });
    }, 0);

    this.usersService.getExtract(this.authService.user.id).subscribe((res) => {
      res.all.forEach((item, index) => {
        item.status === "plan" || item.status === "words"
          ? (this.userTotal += item.points)
          : (this.userTotal -= item.points);

        item.status === "plan" || item.status === "words"
          ? this.savedValues.push(
              (this.savedValues[index - 1] ? this.savedValues[index - 1] : 0) +
                item.points
            )
          : this.savedValues.push(
              (this.savedValues[index - 1] ? this.savedValues[index - 1] : 0) -
                item.points
            );

        this.invitedUsers = res.invitedUsers;
      });
    });

    this.requestForm = this.formBuilder.group({
      pix: ["", Validators.required],
      value: ["", Validators.required],
      type: ["", Validators.required],
    });
  }

  getExtract(event?: PageEvent) {
    this.usersService
      .getExtract(this.authService.user.id, event.pageSize, event.pageIndex + 1)
      .subscribe((res) => {
        console.log(res);
        this.page = {
          ...this.page,
          totalPages: res.totalPages,
          totalElements: res.totalElements,
        };
        const rows = new Array<any>();
        res.data.forEach((item, index) => {
          if (res.current_page > 1) {
            index += (res.current_page - 1) * res.per_page;
          }
          rows.push({
            id: item.id,
            date: new Date(
              item.request_date ? item.request_date.replace(/-/g, ",") : ""
            ).toLocaleDateString(),
            description: this.formatDescription(
              item.status,
              item.redeemer_name
            ).toUpperCase(),
            value: item.value,
            points: item.points,
            total: this.savedValues[index],
            status: this.formatType(item.status),
            redeemer: item.redeemer_name,
            paid: new Date(
              item.paid_at ? item.paid_at.replace(/-/g, ",") : ""
            ).toLocaleDateString(),
          });
        });
        this.dataSource.data = [...rows];
      });
    return event;
  }

  formatDescription(description: string, redeemerName?: string): string {
    if (description === "pending" || description === "paid") {
      return "Solicitação de transferência de pontos";
    } else if (description === "plan" || description === "words") {
      return `Pontos ganhos ${
        description === "plan" ? "do Plano" : "da IA"
      } de ${redeemerName}`;
    }
  }

  formatType(type: string): string {
    switch (type) {
      case "pending":
        return "Pendente";
      case "paid":
        return "Transferido";
      default:
        return "Crédito";
    }
  }

  handleForm() {
    console.log(this.requestForm.value);
    if (this.requestForm.invalid) {
      this.toastr.error("Por favor, preencha todos os campos!");
      return;
    }

    if (this.requestForm.value.value > this.userTotal / 100) {
      this.toastr.error(
        "Você não tem pontos suficientes para essa solicitação!"
      );
      return;
    }

    if (this.requestForm.value.value < (20.0).toFixed(2)) {
      this.toastr.error("Só é possível reinvidicar valores acima de R$ 20,00!");
      return;
    }

    this.usersService.pixRequest(this.requestForm.value).subscribe((res) => {
      if (res.msg === "OK") {
        this.toastr.success("Solicitação enviada com sucesso!");
        this.userTotal -= this.requestForm.value.value * 100;
      } else {
        this.toastr.error("Sua solicitação não foi enviada!");
      }
    });
  }
}
